import HelpAction from "./HelpAction";
import Legenda from "./Legenda";
import PainelOd from "./PainelOd";
import { useState } from "react";
import { limpa, limpaLegenda, limpaloc, completaLest, completEst, valid, haEstMP, limparResultados, download, onCritChange2, onSpecChange2, onSpecBlur2, cparte2, sh2 } from "./Aux.js";

const Odv = (props) => {

    props.setComp('odv');
    document.title = "bqmaps";
    document.querySelector('meta[name="description"]').setAttribute('content','Metro do Porto. Consultar origens ou destinos de viagens. Query journey origins or destinations.');
    
    const [csv, setCsv] = useState('');
    var specs = {...props.specs};

    // inicializa variáveis gerais do serviço odv
    let cp = [ 'CPCamp', 'CPCont','CPRioT','CPCabe','CPErme','CPAgSa','CPSuza','CPValo','CPVala','CPFran','CPMada',
            'CPEspi','CPMira','CPGran','CPAgud','CPCoim','CPDeve','CPGenT','CPSBen','CPTrav','CPSRom','CPTrof',
            'CPSFru','CPPort','CPLean'];
    let zonas = ['GDM1','GDM2','GDM3','MAI1','MAI2','MAI3','MAI4','MAI5','MTS1','MTS2','MTS3','PRT1','PRT2','PRT3',
            'PV_VC','TRF1','TRF2','TRF3','VCD3','VCD8','VLG1','VLG2','VLG3','VNG1','VNG2','VNG3','VNG4','VNG5','VNG8'];
    
    function odvQuery(e){
        e.preventDefault();
        limpaLegenda();
        let s = {...props.specs};
        var orde = "origem";
        if(props.specs.od === 'Destino'){
            orde = "destino";
        }
        var d = 'odvu';
        var txtd = "Úteis";
        if(props.specs.dias === 'Todos'){
            d = 'odvt';
            txtd = "Todos";
        }
        let est = props.specs.est;
        if (est !== '') {
            est = est.split(" ");
            est = limpaloc(est, props.ling);
        }
        if (s.est.length < 1 && !props.specs.la && !props.specs.az && !props.specs.verm && !props.specs.vi && !props.specs.verd && !props.specs.tc && !props.specs.ptc && !props.specs.am ) {
            est = ["0"];
        };
        s.est = est.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let lest = [];
        let x = "";
        let j = 0;
        for (let i = 0; i < est.length; i++) {
          if (est[i] < 83) {
              x = props.varGlob.e[parseInt(est[i])];
          } else {
              if (est[i] < 198) {
                  x = cp[parseInt(est[i])-173];
              } else {
                  x = zonas[parseInt(est[i])-198];
              }
          }
          j++;
          if (j === 12){
              x = "<br>" + x;
              j=0;
          }
          if (x !== "") lest.push(x);
        }
        let anos = props.specs.anos;
        if (anos === '') {
            anos = '2018 2019 2020 2021';
        }
        anos = anos.split(" ");
        anos = limpa(anos, 2018, 2021, props.ling, 2021);
        if( anos.length < 1) {
            anos = ['2018', '2019', '2020', '2021'];
            alert('Input errado para anos foi substituído. / Wrong input for years was replaced.')
        };
        s.anos = anos.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let meses = props.specs.meses;
        if (meses === '') {
            meses = '1 2 3 4 5 6 7 8 9 10 11 12';
        }
        meses = meses.split(" ");
        meses = limpa(meses, 1, 12, props.ling, 2);
        if( meses.length < 1) {
            meses = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
            alert('Input errado para meses foi substituído. / Wrong input for months was replaced.')
        };
        let lmeses = [];
        for (let i = 0; i < meses.length; i++) {
            lmeses.push(props.varGlob.m[parseInt(meses[i])-1]);
        }
        s.meses = meses.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        let horas = props.specs.horas;
        if (horas === '') {
            horas = '1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24';
        }
        horas = horas.split(" ");
        horas = limpa(horas, 1, 24, props.ling, 8);
        if( horas.length < 1) {
            horas = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
            alert('Input errado para horas foi substituído. / Wrong input for hours was replaced.')
        };
        s.horas = horas.toString().replace(/,/g, ' ');
        props.setSpecs(s);
        specs = s;
        let mensagem = "Coloridas estações em função do número de viagens<br>";
        let trocos = {'la': props.specs.la, 'az': props.specs.az, 'verm': props.specs.verm, 'verd': props.specs.verd, 'ptc': props.specs.ptc, 'vi': props.specs.vi, 'tc': props.specs.tc, 'am': props.specs.am}
        lest = completaLest(lest, trocos);
        mensagem += "Com " + orde + " em: " + lest; 
        mensagem += "<br>Nos dias:      "  + txtd; 
        mensagem += "<br>Do(s) ano(s):      "  + anos; 
        mensagem += "<br>No(s) mes(es) de:     " + lmeses;
        mensagem += "<br>Na(s) hora(s):     " + horas;
        let filtro = anos + ";" + lmeses + ";" + horas + ";" + txtd + ";Com " + orde + ";" + lest
        const params = {
          "serv": "odv",
          "estv": completEst(est, trocos),
          "anosv": anos,
          "mesesv": meses,
          "horasv": horas,
          "dv": d,
          "ordev": orde
        };
        odvFetchAsync (
            "/bqmapsnode/?params="  + JSON.stringify(params), est, filtro
        );
    }
    
    async function odvFetchAsync(url, lista, filtro) { 
        let response = await fetch (url, {
            mode: 'no-cors',
            credentials: 'same-origin',
        });
        if (response.ok) {
            let resultados = await response.json();
            if (resultados != null) {
                // se todas as origens/destinos fixados maiores que 82
                if (!haEstMP(lista)){
                    // tirar destinos > 82 dos resultados
                    resultados = limparResultados(resultados);
                }
            }
            if (resultados != null && resultados.length > 0) {
                console.log (resultados);
                let s = {...specs};
                s.res = resultados;
                props.setSpecs(s);
                odvSaveCsv(resultados, filtro);
            } else {
                odvAlertaDados();
            }
            return resultados;
        } else {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        }
    };

    function odvAlertaDados() {
        if (props.ling === 'pt') {
            alert ('Não há dados para o período especificado! Só de Jan 2018 a Fev 2021, inc. (excepto Abr 2020)');
        } else {
            alert ('No data for the specified period! Only for Jan 2018 to Feb 2021, inc. (Apr 2020 excluded)')
        }
    }
    
    async function odvSaveCsv(resultados, filtro){
        setCsv('');
        let ponto = resultados[0];
        let campo = Object.keys(ponto);
        let nloc = resultados.length;
        let csvCont = "Anos;Meses;Horas;Dias;O/D Viagens;Estações \n";
        csvCont = csvCont + filtro + "\n \n";
        csvCont = csvCont + "N.º;Código;Viagens \n";
        for (let i=0; i<nloc; i++){
            let j = resultados[i][campo[0]];
            csvCont = csvCont + j + ";";
            if (j < 173) {
                csvCont = csvCont + props.varGlob.e[j] + ";";
            } else {
                if (j < 198) {
                    csvCont = csvCont + cp[j-173] + ";";
                } else {
                    csvCont = csvCont + zonas[j-198] + ";";
                }
            }
            csvCont = csvCont + parseInt(resultados[i][campo[3]]) + "\n";
        }
        let response = await fetch ("/bqmapsnode/?fileToWrite=" + encodeURIComponent(csvCont), {
            mode: 'no-cors',
            credentials: 'same-origin',
        })
        let fileName = await response.json();
        console.log (fileName);
        if (!response.ok) {
            console.log(response.headers);
            console.log('HTTP ERROR: ' + response.status);
        } setCsv(fileName);
    }
      
    /* useEffect(() => {
        document.getElementById("menu").style.marginLeft = '160px';
    }, [] ); */

    
    return ( 
        <div className="ode">
            <div id="toast"></div>
            <div id="stats">
                <div id="menu">
                    <HelpAction 
                        ling={props.ling} 
                        titPt={"Colorir estações em função do número de viagens"}
                        titUk={"To color stations according to the number of journeys"}
                        helpPt={"https://docs.google.com/presentation/d/1XPkErss7k0pegyRr1ZfnUxdgTS1RWgLQOOcLmtyX-P0/edit?usp=sharing"}
                        helpUk={"https://docs.google.com/presentation/d/1PRA_dtHwrkW8n_84TNLQJqZ6CPhMdDMriB0ZMlEFj2k/edit?usp=sharing"}
                        varGlob={props.varGlob}
                        onSpecChange2={onSpecChange2}
                        specs={specs}
                        setSpecs={props.setSpecs}
                        query={odvQuery}
                        csv={csv}
                        download={download} />
                    <PainelOd
                        ling={props.ling}
                        specs={props.specs}
                        setSpecs={props.setSpecs}
                        setComp={props.setComp}
                        valid={valid}
                        onCritChange2={onCritChange2}
                        sh2={sh2}
                        onSpecChange2={onSpecChange2}
                        onSpecBlur2={onSpecBlur2}
                        cparte2={cparte2}
                        varGlob={props.varGlob}
                        BotA1={'OD Et'}
                        TitA1={"Colorir estações em função do número de etapas"}
                        RefA1={"ode"}  />
                    <Legenda />
                </div>   
            </div>
        </div>
        
    );
}

export default Odv;